//@ts-ignore
//@ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import { modalSteps } from "../../Store/simulate/actions";
import { quoteDataModal } from "../../Store/quote/actions";

import ModalAR from "./FormElements/ModalAR";
import ModalErrores from "./FormElements/ModalErrores";
import BreadCrumbs from "../BreadCrumbs";

import NavResponsive from "../../Components/FormElements/NavResponsive";
import Button from "../../Components/FormElements/Button";
import CardAprobar from "../../Components/FormElements/CardAprobar";
import FormTitle from "../../Components/FormElements/FormTitle";
import Footer from "../../Components/Footer";

import IconBack from "../../Resources/svg/Icons/IconBack";

import { handleState } from "../../Utils/utils";
import {
  cardProducts,
  getTitleCase,
} from "../../Utils/simulaciones/simulaciones";
import useBeforeFirstRender from "../../customHook/useBeforFirstRenderQuote";

export const ApproveQuote = () => {
  const inputEl = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const data = location.state;
  const client = data.datosCliente;
  const codigoPorducto = data.producto.codigo;
  const [loadingClick, setLoadingClick] = useState<any>(false);
  const [isFill, setIsFill] = useState<boolean>(false);
  const [loading, setLoading] = useState<any>(false);
  const [conditionStateRI, setConditionStateRI] = useState<any>("");
  const { channel } = useSelector((state: any) => state.login);
  const capabilities = useSelector((state: any) => state.login.access_configuration.capabilities);
  const clientData = client ? client.datosParticulares : null;
  const beneficiary = client ? client.beneficiarios.personalizados : null;
  const cotizacion = data.datosCotizacion;
  const { numCotizacion } = data;
  const datoRI =
    data.datosEmision && data.datosEmision.numRelIng !== undefined
      ? data.datosEmision.numRelIng
      : "";

  const [codigoIR, setCodigoIR] = useState(datoRI);
  let cardCoti: any[] = [];
  let tramaCoti: any[] = [];

  const [tipoModal, setTipoModal] = useState("");

  useBeforeFirstRender(client);

  const onSubmit = async (e: any) => {
    setReduxModal();
    setTipoModal("Aprobar");
    dispatch(modalSteps(true));

    e.preventDefault();
  };

  const rechazarCotizacion = () => {
    setReduxModal();
    setTipoModal("Rechazar");
    dispatch(modalSteps(true));
  };

  const setReduxModal = () => {
    const request = {
      body: {
        idCotizacion: data.idCotizacion,
        codigoRecaudo: codigoIR,
      },
    };
    dispatch(quoteDataModal(request));
  };

  const handleChange = (e: any) => {
    if (e.target.value.length > 10) {
      return;
    }
    setCodigoIR(e.target.value);
  };

  const navigationPrev = () => {
    history.goBack();
  };

  if (client) {
    const nameCli = clientData.names;
    const ApeCli = clientData.firstName.concat(" ", clientData.lastName);

    const firstName = nameCli ? getTitleCase(nameCli) : "";

    const lastName = ApeCli ? getTitleCase(ApeCli) : "";

    const sexCli = clientData.sexo === "F" ? "Femenino" : "Masculino";

    const urbanization = clientData.address.urbanization
      ? `, Urb. ${clientData.address.urbanization}`
      : clientData.address.urbanization;
    const dirCli = clientData.address.type.concat(
      ". ",
      clientData.address.name,
      ", ",
      clientData.address.number,
      " ",
      urbanization,
      ", ",
      clientData.address.nameUbigeo.district
    );
    let herederos: any[] = [];
    if (beneficiary.length > 0 && beneficiary[0].nombres !== "") {
      beneficiary.map((heredero: any) =>
        herederos.push({
          nombre: heredero.nombres,
          apellido: heredero.apePaterno.concat(" ", heredero.apeMaterno),
          tipoDoc: heredero.tipoDoc,
          dni: heredero.documento,
          fecNacimiento: heredero.fecNacimiento,
          sexo: heredero.sexo,
          numCelular: heredero.numCelular,
          correoElectronico: heredero.correoElectronico,
          relacion: heredero.relacion,
          beneficio: heredero.porcentaje,
        })
      );
    }

    cardCoti = cardProducts(
      data,
      tramaCoti,
      firstName,
      lastName,
      clientData,
      sexCli,
      dirCli,
      herederos
    );
  }

  const hideInput =
    data.estado === "rechazada" || data.estado === "vencida"
      ? "d-none"
      : "d-show";

  const titleDetail =
    data.estado === "pendiente"
      ? "Revisar cotización"
      : "Detalle de cotización";

  const numEmision = data.datosEmision ? data.datosEmision.numRelIng : "";

  const isEmptyValue = () => {
    const elem = inputEl.current as HTMLElement | null;
    // const contentInput = elem.querySelectorAll(".input-field");

    if (elem) {
      const contentInput = elem.querySelectorAll(".input-field");

      if (datoRI.length === 0) {
        contentInput.forEach((el: any) => {
          el.classList.remove("is-fill");
        });
      }
      if (datoRI.length > 1) {
        contentInput.forEach((el: any) => {
          el.classList.add("is-fill");
        });
      }
      return datoRI.length === 0 ? false : true;
    }
  };

  const setFill = () => {
    setIsFill(isEmptyValue() || false);
  };

  useEffect(() => {
    setFill();

    setCodigoIR(datoRI);
  }, []);

  useBeforeFirstRender(client);

  useEffect(() => {
    if (data.estado === "pendiente") {
      setConditionStateRI("");
    }

    if (data.estado === "porFirmar") {
      setConditionStateRI("");
    }

    if (
      data.estado !== "pendiente" &&
      data.estado !== "firmado" &&
      data.estado !== "porFirmar" &&
      data.estado !== "revision"
    ) {
      setConditionStateRI("disabled");
    }
  }, [data]);

  const handleUnderstood = () => {
    history.push("/cotizaciones");
  };

  console.log("cardCoti", cardCoti);
  return (
    <>
      <div className="wrap">
        <NavResponsive
          position={0}
          title={titleDetail}
          subtitle=" "
          hidden={true}
          justBack={true}
        />
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Aprobaciones" }, { link: "Revisar" }]}
            />
            <div className="back-responsive">
              <div className="back-responsive__box">
                <IconBack
                  className="nav-case__back"
                  onClick={() => history.push(-1)}
                />
                <div className="back-responsive__text">Volver</div>
              </div>
            </div>
            <div className="nav-case__routing">
              <IconBack className="nav-case__back" onClick={navigationPrev} />
              <div className="nav-case__title">{titleDetail}</div>
            </div>
          </div>
          <div className="form-register approve-quote">
            {data.estado !== "pendiente" ? (
              <FormTitle title={`Cotización con ${handleState(data.estado)}`} />
            ) : (
              <FormTitle
                title="Verificación de datos"
                parrafo="Revisemos que los datos ingresados sean correctos"
              />
            )}
            <form ref={inputEl} onSubmit={onSubmit}>
              {cardCoti.map((coti, index) => (
                <CardAprobar key={index} loading={loading} data={coti} dataAdjuntar={data} codigoPorducto={codigoPorducto} showFile={true}/>
              ))}

              { capabilities.canViewButtonsApprove && capabilities.canViewButtonsApprove === true && data.estado !== "firmado" && <>
                <div className={hideInput}>
                <div
                  className={
                    "clientForm__control input-field" +
                    (isFill ? " is-fill" : "")
                  }
                >
                  <input
                    id="recaudo"
                    type="number"
                    name="recaudo"
                    value={codigoIR}
                    className={conditionStateRI}
                    autoComplete="off"
                    onChange={handleChange}
                    disabled={capabilities.canUploadRI === true ? false : true}
                    defaultValue={numEmision}
                  />
                  <label htmlFor="recaudo">Relación de Ingreso (RI)</label>
                </div>
              </div>

              <div className="form-register__border"></div>
              <div className="form-register__buttom">
                {data.estado !== "pendiente" &&
                data.estado !== "firmado" &&
                data.estado !== "porFirmar" &&
                data.estado !== "revision" ? (
                  <Button
                    type="submit"
                    className={`form-register__submit ${
                      loadingClick ? "is-loading" : ""
                    }`}
                    onClick={handleUnderstood} // cambiar de acuerdo al channel
                  >
                    Entendido
                  </Button>
                ) : (
                  <>
                    <div
                      className="form-register__quotation"
                      onClick={rechazarCotizacion}
                    >
                      Rechazar cotización
                    </div>
                    <div
                      className="form-register__quotation"
                      onClick={rechazarCotizacion}
                    >
                      Rechazar
                    </div>
                    <Button
                      type="submit"
                      className={loadingClick ? "is-loading" : ""}
                      disabled={codigoIR === "" ? true : false}
                    >
                      Aprobar
                    </Button>
                  </>
                )}
              </div></>}
            </form>
          </div>
        </div>
      </div>
      <ModalErrores />
      <ModalAR
        type={tipoModal}
        quoteData={data}
        numCotizacion={numCotizacion}
        moneda={cotizacion.moneda}
      />
      <Footer />
    </>
  );
};
